// Dashboard constants shared by Home and its sections (kept out of tiles.tsx so that
// file exports components only, for Fast Refresh).

import type { CSSProperties } from 'react';

/**
 * Diagonal hatch laid over a "failed" bar segment so it differs from "succeeded"
 * by texture, not colour alone (WCAG AA).
 */
export const FAILED_HATCH = 'repeating-linear-gradient(45deg, rgba(0,0,0,0.22) 0 2px, transparent 2px 5px)';

/** Short weekday names indexed by `Date#getUTCDay()` — the dashboard buckets on UTC days. */
export const WEEKDAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** The 4-up KPI grid every dashboard strip uses. */
export const KPI_GRID: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
  gap: 10,
  marginBottom: 12,
};
